// extracted by mini-css-extract-plugin
export default {"listItemContainer":"ManageDeliveryAddressStack_listItemContainer__R21Zg","listItem":"ManageDeliveryAddressStack_listItem__ppEoA","btn":"ManageDeliveryAddressStack_btn__FVg6e"};